<template>
    <section class="col-xs-12 col-sm-5">
        <div class="calendar__info">
            <div class="calendar__info__item">
                <h4 class="calendar__info__title">{{ $t('CAN_I_USE_BRASTER') }}</h4>

                <div class="is-relative" v-if="brasterAllowed">
                    <img class="img-info" src="../../assets/images/icons/ico-ok-green.png" />
                    <div class="content">
                        <p class="highlight">{{ $t('YES') }}</p>
                        <router-link :to="'/moje-dane/'" class="arrow-link">
                            {{ $t('CHECK_IF_DATA_ACTUAL') }} <img src="./../../assets/images/arrow-red.png" />
                        </router-link>
                    </div>
                </div>

                <div class="is-relative" v-if="!brasterAllowed">
                    <img class="img-info" src="../../assets/images/icons/ico-not-ok.png" />
                    <div class="content">
                        <p class="highlight">{{ $t('NO') }}</p>
                        <router-link :to="'/moje-dane/'" class="arrow-link">
                            {{ $t('CHECK_IF_DATA_ACTUAL') }} <img src="./../../assets/images/arrow-red.png" />
                        </router-link>
                    </div>
                </div>

                <div v-if="!brasterAllowed" class="box-shadow calendar__info__tooltip bottom mt-3">
                    {{ $t('UNFORTUNATELY_YOU_CAN_NOT') }}
                    <a href="#" @click="linkClicked($t('LINK_WARNINGS'))">{{ $t('ALL_CONTRAINDICATIONS') }}</a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { linkClicked } from './../../main';

export default {
    computed: {
        brasterAllowed() {
            return (
                this.$store.getters.brasterAllowed &&
                this.$store.state.survey.survey.section2.q1 === 'NO' &&
                this.$store.state.survey.survey.section2.q2 === 'NO' &&
                this.$store.state.survey.survey.section2.q3 === 'NO' &&
                this.$store.state.survey.survey.section2.q4 === 'NO'
            );
        },
    },
    methods: {
        linkClicked(link) {
            linkClicked(link);
        },
    },
};
</script>

<style scoped>
.img-info {
    position: absolute;
    top: 0;
    left: 0;
}

.content {
    padding-left: 55px;
}

.highlight {
    font-size: 20px;
    line-height: 1;
    font-weight: 700;
    margin: 0;
    padding-top: 5px;
}

.arrow-link img {
    height: 7px;
    margin: 0 0 2px 3px;
}
</style>



// WEBPACK FOOTER //
// braster-disallowed.vue?321834e2